import { useUserStore } from '@st/user/stores/useUserStore'
import { useCurrenciesStore } from '@st/payments/stores/useCurrenciesStore'
import { provideBonusesDeps } from '@st/bonuses/useDeps'
import { useCasinoStore } from '@st/casino/stores/useCasinoStore'
import { useAccountsStore } from '@st/payments/stores/useAccountsStore'
import { useConverterStore } from '@st/payments/stores/useConverterStore'
import GameCard from '@st/casino/components/GameCard/GameCard.vue'
import { useGameInitStore } from '@st/casino/stores/useGameInitStore'
import { useModalConfig } from '../modal.config'
import type { IconName } from '@st/ui/components/StIcon/types'
import VipClubHeader from '@st/vip-club/components/VipClubHeader/VipClubHeader.vue'
import VipClubBadge from '@st/vip-club/components/VipClubBadge/VipClubBadge.vue'

export default defineNuxtPlugin({
  name: 'bonusesDeps',
  dependsOn: ['paymentsDeps', 'casinoDeps'],
  setup: () => {
    const userStore = useUserStore()
    const { isAuthenticated, user } = storeToRefs(userStore)

    const currencyStore = useCurrenciesStore()
    const { getCurrencyByCode, getCurrencyById } = currencyStore
    const { appCurrency } = toRefs(currencyStore)
    const { convert } = useConverterStore()

    const accountsStore = useAccountsStore()
    const { getAccountById } = accountsStore
    const modals = useModalConfig()

    const { getCategoryNameById } = useCasinoStore()
    const { isGameLoading } = storeToRefs(useGameInitStore())

    provideBonusesDeps({
      bonusesTooltips: {
        freespinTooltip: modals.value.freespinTooltip.component,
        freebetTooltip: modals.value.freebetTooltip.component,
        regularBonusTooltip: modals.value.regularBonusTooltip.component,
        depositBonusTooltip: modals.value.depositBonusTooltip.component,
        cashBonusTooltip: modals.value.cashBonusTooltip.component,
      },
      GameCard,
      isAuthenticated,
      referralCode: computed(() => user.value?.referralCode),
      appCurrencyCode: computed(() => appCurrency.value.code),
      getCurrencyIcon: (code: string) =>
        getCurrencyByCode(code)?.icon ?? ('' as IconName),
      getCurrencyIconById: (id: number) => getCurrencyById(id)?.icon,
      getCurrencyCodeById: (id: number) => getCurrencyById(id)?.code,
      getCategoryNameById,
      getAccountById,
      getReferralCurrency: (id: number) => {
        const currency = getCurrencyById(id)
        if (!currency) return undefined

        return {
          icon: currency.icon,
          code: currency.code,
        }
      },
      convert,
      isGameLoading,
      VipClubHeader,
      VipClubBadge,
    })
  },
})
